import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import CareUserActivity from '../src/services/api/careUserActivity';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    raiseScreenTitle: 'Self Care',
    /* store the care-user activity controller */
    raiseComplaintCatVal: [],
    helpTopicResult: [],
    filterText: '',
    val: {
      categoryId: null,
      subCategoryOne: null,
      subCategoryTwo: null,
      subCategoryThree: null,
      subCategoryFour: null,
      date: null,
      agentId: null,
    },
    /* phase 2 category flow Implementation */
    subCategoryListing: [],
    subSubCategoryListing: [],
    mainCategoryInfo: {
      mainCategoryName: '',
      mainCategoryID: '',
      categoryNameEng: '',
    },
    levelOneCategory: {
      levelOneCategoryName: '',
      levelOneCategoryID: '',
      levelOneCategoryIndex: '',
      levelOneEngTitle: '',
    },
    levelTwoCategory: {
      levelTwoCategoryName: '',
      levelTwoCategoryID: '',
      levelTwoCategoryIndex: '',
      levelTwoEngTitle: '',
    },
    levelThreeCategory: {
      levelThreeCategoryName: '',
      levelThreeCategoryID: '',
      levelThreeCategoryIndex: '',
      levelThreeEngTitle: '',
    },
    levelFourCategory: {
      levelFourCategoryName: '',
      levelFourCategoryID: '',
      levelFourCategoryIndex: '',
      levelFourEngTitle: '',
    },
    attachementVal: {
      attachmentRequired: '',
      topicName: '',
    },
    helpraiseTitle: '',
    /* help topic value */
    helpTopicLog: {
      agentId: null,
      categoryId: null,
      createdBy: null,
      createdOn: null,
      helpId: null,
      language: null,
      mediaType: 'NONE',
      popular: true,
      subCategoryId1: null,
      subCategoryId2: null,
      subCategoryId3: null,
      subCategoryId4: null,
    },
    isKnowLedgeCenter: null,
    helpTopicList: [],
    /* raisecomplaint variable */
    combinedSubCatgoryName: null,
    transactionId: null,
    ticketId: null,
    /* session Validate data */
    sessionPayload: {
      agentId: '',
      appRegisterUser: '',
      city: '',
      clientType: '',
      contactName: '',
      firmName: '',
      lang: '',
      loginId: '',
      mobileNumber: '',
      mode: '',
      product: '',
      state: '',
      ticketId: '',
      txnId: '',
      udf3: '',
      udf4: '',
      udf5: '',
    },

    smaDetails: {
      agentID: null,
      sessionID: '',
      tokenNumber: null,
    },
    /* global variable for api */
    mode: 'WEB',
    agentid: '',
    lang: 'EN',

    //Transaction History
    historyModuleSession: '',
    filterData: [],
    initialFilters: {},
    tabs: [],
    validMainCategoryIds: [],
    notValidSubCategoryIds: [],
    selectedProductForHistory: '',
    selectedTxnId: '',

    //Get Product Name
    productNamePayload: {
      category: '',
      subCategory: '',
    },
    //Props at Transaction History
    propsForHistoryModule: {
      attachmentRequired: false,
      pageName: '',
      attachmentName: '',
    },

    //raisecomplaint display
    raiseBtnDisplay: false,
    prevRoute: '',
    productRelated: false,
    source: 'SELFCARE',
  },
  getters: {
    /* store category flow */

    getSource: state => state.source,

    getmainCategoryInfo: state => {
      return state.mainCategoryInfo;
    },
    getKnowledgeCenter: (state, value) => {
      return state.isKnowLedgeCenter;
    },
    getLevelOneCategory: state => {
      return state.levelOneCategory;
    },
    getLevelTwoCategory: state => {
      return state.levelTwoCategory;
    },
    getLevelThreeCategory: state => {
      return state.levelThreeCategory;
    },
    getLevelFourCategory: state => {
      return state.levelFourCategory;
    },
    getAttachement: state => {
      return state.attachementVal;
    },
    /* help topic values */
    getHelpTopicLog: state => {
      return state.helpTopicList;
    },
    /* Raise complaint Values */
    TRANSACTIONID: state => {
      return state.transactionId;
    },
    RAISECOMPLAINTARRAY: state => {
      return state.raiseComplaintCatVal;
    },
    /* session Api values */
    SESSIONPAYLOAD: state => {
      return state.sessionPayload;
    },
    /* sub category flow */
    SUBCATEGORYLISTING: state => {
      return state.subCategoryListing;
    },
    SUBSUBCATEGORYLISTING: state => {
      return state.subSubCategoryListing;
    },
    getraiseTitle: state => {
      return state.helpraiseTitle;
    },

    /* global value getting */
    getAppMode: state => {
      return state.mode;
    },
    getAppAgentId: state => {
      return state.agentid;
    },
    getAppLang: state => {
      return state.lang;
    },

    //Transaction History
    getHistoryModuleSession: state => {
      return state.historyModuleSession;
    },

    getFiltersbyProductName: store => (productName: string) => {
      if (store.filterData.length != 0) {
        const filterObject = store.filterData.find(e => {
          return e.product === productName;
        });

        if (filterObject) {
          return filterObject.filter.filter(e => e.filterEnableFlag == 'Y');
        } else {
          return [];
        }
      } else {
        return [];
      }
    },

    getInitialFiltersbyProductName: store => (productName: string) => {
      if (store.initialFilters[productName] && store.initialFilters[productName].length > 0) {
        return store.initialFilters[productName];
      } else {
        return [];
      }
    },

    getMode: store => store.sessionPayload.mode,

    getTabs: store => store.tabs,

    getSelectedProductForHistory: store => store.selectedProductForHistory,

    getSelectedTxnId: store => store.selectedTxnId,

    getProductNamePayload: store => store.productNamePayload,

    getPropsForHistoryModule: store => store.propsForHistoryModule,
    //raisebtn display of helptopic
    getRaiseBtnDisplay: (state, btnDisplay) => {
      state.raiseBtnDisplay = btnDisplay;
    },
    getSMADetails: state => state.smaDetails,
  },
  mutations: {
    /* add category name for raisecomplaint post request */
    setSource: (state, sourceName) => (state.source = sourceName),

    TRANSACTIONIDVAUE: (state, id) => {
      state.transactionId = id;
    },
    SESSIONPAYLOADVALUE: (state, values) => {
      state.sessionPayload = values;
    },
    /* subcategory flow */
    setmainCategoryInfo: (state, value) => {
      state.mainCategoryInfo = value;
    },
    setKnowledgeCenter: (state, value) => {
      state.isKnowLedgeCenter = value;
    },
    setlevelOneCategory: (state, value) => {
      state.levelOneCategory = value;
    },
    setlevelTwoCategory: (state, value) => {
      state.levelTwoCategory = value;
    },
    setlevelThreeCategory: (state, value) => {
      state.levelThreeCategory = value;
    },
    setlevelFourCategory: (state, value) => {
      state.levelFourCategory = value;
    },
    setHelpTopics: (state, value) => {
      state.helpTopicResult = value;
    },
    setFilterText: (state, value) => {
      state.filterText = value;
    },
    setAttachment: (state, value) => {
      state.attachementVal = value;
    },
    setprevRoute: (state, value) => {
      state.prevRoute = value;
    },
    setProductRelated: (state, value) => {
      state.productRelated = value;
    },
    clearAttachment: state => {
      state.attachementVal.attachmentRequired = '';
      state.attachementVal.topicName = '';
    },
    setraiseTitle: (state, val) => {
      state.helpraiseTitle = val;
    },
    /* sub category flow */
    subCategoryValue: (state, category) => {
      state.subCategoryListing = category;
    },
    subSubCategoryValue: (state, category) => {
      state.subSubCategoryListing = category;
    },
    CLEAR_CATEGORYNAME: state => {
      state.combinedSubCatgoryName = null;
      state.transactionId = null;
    },
    CLEAR_MAINCATEGORYINFO: state => {
      state.mainCategoryInfo.mainCategoryID = '';
      state.mainCategoryInfo.mainCategoryName = '';
      state.mainCategoryInfo.categoryNameEng = '';
    },
    CLEAR_PRODUCTID: state => {
      state.levelOneCategory.levelOneCategoryID = '';
      state.levelOneCategory.levelOneCategoryIndex = '';
      state.levelOneCategory.levelOneCategoryName = '';
      state.levelOneCategory.levelOneEngTitle = '';
    },
    CLEAR_LEVELTWOCATEGORY: state => {
      state.levelTwoCategory.levelTwoCategoryID = '';
      state.levelTwoCategory.levelTwoCategoryIndex = '';
      state.levelTwoCategory.levelTwoCategoryName = '';
      state.levelTwoCategory.levelTwoEngTitle = '';
    },
    CLEAR_LEVELTHREECATEGORY: state => {
      state.levelThreeCategory.levelThreeCategoryID = '';
      state.levelThreeCategory.levelThreeCategoryIndex = '';
      state.levelThreeCategory.levelThreeCategoryName = '';
      state.levelThreeCategory.levelThreeEngTitle = '';
    },
    CLEAR_LEVELFOURCATEGORY: state => {
      state.levelFourCategory.levelFourCategoryID = '';
      state.levelFourCategory.levelFourCategoryIndex = '';
      state.levelFourCategory.levelFourCategoryName = '';
      state.levelFourCategory.levelFourEngTitle = '';
    },
    /* user activity log */
    RAISECOMPLAINTARRAY: (state, name) => {
      let key = name.key,
        route = name.route,
        len = state.raiseComplaintCatVal.length;

      if (
        route === 'SelfcareRaiseComplaint' ||
        route === 'CategoryList' ||
        route === 'HistoryRaiseComplaint' ||
        route === 'knowledgeCenter'
      ) {
        state.val = {
          categoryId: null,
          subCategoryOne: null,
          subCategoryTwo: null,
          subCategoryThree: null,
          subCategoryFour: null,
          date: new Date(),
          agentId: agentid,
        };
        state.val[key] = name.name;
        state.raiseComplaintCatVal.push(state.val);
      } else if (state.raiseComplaintCatVal[len - 1][key] != null) {
        let newVal = JSON.parse(JSON.stringify(state.raiseComplaintCatVal[len - 1]));
        if (route == 'levelOne') {
          newVal.subCategoryOne = null;
          newVal.subCategoryTwo = null;
          newVal.subCategoryThree = null;
          newVal.subCategoryFour = null;
        } else if (route === 'levelTwo') {
          newVal.subCategoryTwo = null;
          newVal.subCategoryThree = null;
          newVal.subCategoryFour = null;
        } else if (route === 'levelThree') {
          newVal.subCategoryThree = null;
          newVal.subCategoryFour = null;
        } else if (route === 'levelFour') {
          newVal.subCategoryFour = null;
        }
        newVal[key] = name.name;
        state.raiseComplaintCatVal.push(newVal);
      } else {
        state.raiseComplaintCatVal[len - 1][key] = name.name;
      }

      //state.val[key] = name.name;
      if (state.raiseComplaintCatVal.length == 5) {
        CareUserActivity.userActivityLog(state.raiseComplaintCatVal).then(response => {
          console.log('Response');
        });
      }
    },
    /* help topic log */
    setHelpTopicLog: (state, helpCount) => {
      state.helpTopicList.push(helpCount);
      if (state.helpTopicList.length == 5) {
        CareUserActivity.userHelpTopicLog(state.helpTopicList).then(response => {
          console.log('Help Response');
        });
      }
    },
    /* global value setting */
    setAppMode: (state, appMode) => {
      state.mode = appMode;
    },
    setAppAgentId: (state, appAgentid) => {
      state.agentid = appAgentid;
    },
    setAppLang: (state, appLang) => {
      state.lang = appLang;
    },

    //Transaction History
    setHistoryModuleSession: (state, payload) => {
      state.historyModuleSession = payload;
    },

    setFilterData: (store, payload) => {
      store.filterData = payload;
    },

    setInitialFilters: (store, payload) => {
      store.initialFilters = payload;
    },

    setTabs: (store, payload) => {
      store.tabs = payload;
    },

    setSelectedProductForHistory: (store, payload) => {
      store.selectedProductForHistory = payload;
    },

    setSelectedTxnId: (store, payload) => {
      store.selectedTxnId = payload;
    },

    setCategoryName: (store, payload) => {
      store.productNamePayload.category = payload;
    },

    setSMADetails: (state,payload) => {
      state.smaDetails = payload;
   },
    setSubCategoryName: (store, payload) => {
      store.productNamePayload.subCategory = payload;
    },

    setPropsForHistoryModule: (store, payload) => {
      store.propsForHistoryModule = payload;
    },

    //raisebtn display of helptopic
    setraiseBtnDisplay: (state, btnDisplay) => {
      state.raiseBtnDisplay = btnDisplay;
    },
  },
  actions: {
    //Transaction History
    setFilterData: ({ commit }, payload) => {
      commit('setFilterData', payload);
    },

    setInitialFilters: ({ commit }, payload) => {
      commit('setInitialFilters', payload);
    },

    setTabs: ({ commit }, payload) => {
      commit('setTabs', payload);
    },

    setSelectedTab: ({ commit }, payload) => {
      commit('setSelectedTab', payload);
    },

    setSelectedTxnId: ({ commit }, payload) => {
      commit('setSelectedTxnId', payload);
    },
  },
});
